import { Nav } from "./Nav";
import { Count } from "./Count";

export const Base = () => {

    return (
        <div className="w-full flex bg-dayan-gray-50">
            <Nav />

            <Count />

        </div>
    );
}